import { CustomTemplatedMessageVariables } from 'generated-graphql/types';

type TemplateVariables = {
  [key in CustomTemplatedMessageVariables]?: string;
};

export const fillOpeningMessageTemplate = (
  template: string,
  variables: TemplateVariables
): string => {
  return template.replace(/\{\{(\w+)\}\}/g, (match, variable) => {
    const value = variables[variable as CustomTemplatedMessageVariables];
    if (!value) {
      return match;
    }

    return value;
  });
};
